/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsProductDefaults
 */
export interface MelcoModelsProductDefaults {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsProductDefaults
     */
    log_level?: string | null;
}

export function MelcoModelsProductDefaultsFromJSON(json: any): MelcoModelsProductDefaults {
    return MelcoModelsProductDefaultsFromJSONTyped(json, false);
}

export function MelcoModelsProductDefaultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsProductDefaults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'log_level': !exists(json, 'log_level') ? undefined : json['log_level'],
    };
}

export function MelcoModelsProductDefaultsToJSON(value?: MelcoModelsProductDefaults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'log_level': value.log_level,
    };
}


